module.exports = __webpack_public_path__ + "45967dbabba6e11ac9c16645a0d8e23f.png";